import React from "react";
import PropTypes from "prop-types";

import "./history-item.css";

const onDefaultDelete = (id) => {
  console.log("Delete item", id);
};

const onDefaultContextMenu = (e) => {};

const onDefaultPin = (id) => {
  console.log("Pin item", id);
};

/**
 *
 * @param {{
 * src: string,
 * title: string,
 * id: string | number,
 * type: "default" | "red" | "purple" | "orange" | "inverse",
 * date: string
 * }} param0
 * @returns
 */
const HistoryItem = ({
  src = "",
  title,
  id,
  type = "default",
  pinned = true,
  date = "",
  onContextMenu = onDefaultContextMenu,
  onDelete = onDefaultDelete,
  onPin = onDefaultPin,
}) => {
  const colors = {
    default: "history-item-default",
    red: "history-item-red",
    purple: "history-item-purple",
    orange: "history-item-orange",
    inverse: "history-item-inverse",
  };

  // Check type is in colors
  if (!colors[type]) {
    type = "default";
  }

  return (
    <a
      href={`/product?id=${id}`}
      tabIndex={0}
      data-item-id={id}
      onContextMenu={onContextMenu}
      className={`history-item ${colors[type]}`}
      data-testid="history-item-anchor"
    >
      <header className="history-item-header w-full flex justify-between">
        <aside></aside>
        <aside className="flex gap-2">
          <button
            data-testid="history-item-button-pin"
            onClick={(e) => {
              e.preventDefault();
              onPin(id);
            }}
            className="p-2 self-end align-top hover:bg-yellow-500 group hover:fill-white hover:text-white rounded-lg"
          >
            {pinned ? (
              <svg
                data-testid="history-item-pin-on"
                className="h-5 fill-yellow-500 group-hover:fill-white"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <title>pin</title>
                <path d="M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12Z" />
              </svg>
            ) : (
              <svg
                data-testid="history-item-pin-off"
                className="h-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <title>pin-outline</title>
                <path d="M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12M8.8,14L10,12.8V4H14V12.8L15.2,14H8.8Z" />
              </svg>
            )}
          </button>
          <button
            data-testid="delete-history-item-button"
            onClick={(e) => {
              e.preventDefault();
              onDelete(id);
            }}
            className="p-2 self-end align-top hover:bg-red-500 hover:fill-white hover:text-white rounded-lg"
          >
            <svg
              className="h-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <title>trash-can-outline</title>
              <path d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z" />
            </svg>
          </button>
        </aside>
      </header>
      <main className="history-item-body flex-grow flex justify-center items-center overflow-hidden">
        <p className="history-item-title p-3" data-testid="history-item-title">
          {/* Print max 100 character, add ... if over */}
          {title.length > 100 ? `${title.substring(0, 100)}...` : title}
        </p>
      </main>

      <footer className="history-item-footer self-start flex gap-3 items-center">
        <svg
          className="w-5 h-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
        >
          <path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192z" />
        </svg>
        <p className="history-item-date">{date}</p>
      </footer>
    </a>
  );
};

// Set prop types
HistoryItem.propTypes = {
  src: PropTypes.string,
  title: PropTypes.string,
  // ID can be a string or a number
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  date: PropTypes.string,
  pinned: PropTypes.bool,
  onContextMenu: PropTypes.func,
  onDelete: PropTypes.func,
  onPin: PropTypes.func,
};

export default HistoryItem;
